// extracted by mini-css-extract-plugin
export var adjacentSlide = "_q0-9";
export var arrowButtonContainer = "_q0-5";
export var arrowButtonIcon = "_q0-6";
export var carouselArrowButton = "_q0-2";
export var carouselElementContainer = "_q0-1";
export var currentSlide = "_q0-8";
export var left = "_q0-3";
export var otherSlide = "_q0-a";
export var productCarouselContainer = "_q0-0";
export var right = "_q0-4";
export var sliderOverflow = "_q0-7";